/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type HighLevelTimeNumbers_company = {
    readonly id: string;
    readonly " $refType": "HighLevelTimeNumbers_company";
};
export type HighLevelTimeNumbers_company$data = HighLevelTimeNumbers_company;
export type HighLevelTimeNumbers_company$key = {
    readonly " $data"?: HighLevelTimeNumbers_company$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"HighLevelTimeNumbers_company">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "HighLevelTimeNumbers_company",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    }
  ],
  "type": "Company"
};
(node as any).hash = '650e7e75b816b0631475bba318dff414';
export default node;
